import React, { useMemo } from 'react';
import { Redirect } from 'react-router-dom';
import { useParams, useLocation } from 'react-router-dom';
import ErrorView from '@magento/venia-ui/lib/components/ErrorView';

var CollectionRedirect = function CollectionRedirect() {
  var _useLocation = useLocation(),
      search = _useLocation.search;

  var redirectTo = false;

  if (search == 'q=chandeliers' || search == 'chandeliers=1&pendants=1') {
    redirectTo = '/products/view-by-category/ceiling/chandeliers-pendants';
  } else if (search == 'q=loop') {
    redirectTo = '/loop-pendant-104230';
  } else if (search == 'q=Mirrors') {
    redirectTo = '/products/view-by-category/decor/mirrors';
  } else if (search == 'q=Oval') {
    redirectTo = '/products?page=1&hf_fixture_shape%5Bfilter%5D=Oval%2C7166';
  } else if (search == 'q=sconce') {
    redirectTo = '/products/view-by-category/wall';
  } else if (search == 'q=slide') {
    redirectTo = '/slide-pendant-139201';
  } else if (search == 'q=venn') {
    redirectTo = '/venn-pendant-137730';
  } else if (search.includes('?q=')) {
    redirectTo = '/collection-landing/' + search.replace('+', '-').replace('&utm_source=luxe&utm_medium=facebook&utm_campaign=brooklyn', '').replace('&utm_source=Lux+Magazine&utm_medium=Print&utm_campaign=LUXE_sept-oct2022', '').replace(/^\?q\=/, '').replace(' ', '-').replace('%20', '-').toLowerCase();

    if (redirectTo == '/collection-landing/new-traditional') {
      redirectTo = '/products?page=1&hf_new_designs%5Bfilter%5D=1%2C1&hf_style%5Bfilter%5D=Traditional%2C4282';
    }
  } else if (search == 'bath=1') {
    redirectTo = '/collection-landing/bath';
  } else if (search == 'decor=1') {
    redirectTo = '/products/view-by-category/decor';
  } else if (search == 'mini-pendants=1') {
    redirectTo = '/products/view-by-category/ceiling/mini-pendants';
  } else if (search == 'new-designs=1' || search == 'new-designs=1&utm_source=dt&utm_medium=social&utm_campaign=designerstoday') {
    redirectTo = '/products?page=1&hf_new_designs%5Bfilter%5D=1%2C1';
  }

  if (redirectTo) {
    return React.createElement(Redirect, {
      to: redirectTo
    });
  }

  return React.createElement(ErrorView, null);
};

export default CollectionRedirect;